import React from "react";
import Slider from "react-slick";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoPlay: true,
};

function MenuList1Bred({ specialProducts }) {
  return (
    <Slider {...settings}>
      {specialProducts?.map((item) => {
        return (
          <div>
            <section
              className="bredcrumb_section menu_list"
              style={{
                background: `linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${item?.imageURL})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                marginTop: 0,
              }}
            >
              <div className="container">
                <div
                  className="section_title text-center"
                  data-aos="fade-up"
                  data-aos-duration={1500}
                >
                  {item?.specialTitle && (
                    <span className="sub_text">{item?.specialTitle}</span>
                  )}
                  {item?.specialDescription && (
                    <h2>{item?.specialDescription}</h2>
                  )}
                </div>
              </div>
            </section>
          </div>
        );
      })}
    </Slider>
  );
}

export default MenuList1Bred;

